import React from 'react'

export const HelpText = () => {
  return (
    <span>
      You can try again at a later time, or call the Hotline at 1-800-HHS-TIPS
      (1-800-447-8477).
    </span>
  )
}
